type AnalyticsData = Record<string, string | number | boolean>;
type EventName = "quote_opened" | "quote_step_completed" | "quote_submit_attempted" |
  "quote_request_saved" | "quote_submit_failed" | "catalogue_category_selected" |
  "catalogue_quote_clicked" | "contact_phone_clicked";

declare global {
  interface Window {
    umami?: { track(name: string, data?: AnalyticsData): void | Promise<unknown> };
  }
}

// Only fixed labels, catalogue IDs and aggregate counts belong here.
// Never send contact details, custom product text, payloads or idempotency keys.
export function trackEvent(name: EventName, data?: AnalyticsData): void {
  if (typeof window === "undefined") return;
  try {
    const result = window.umami?.track(name, data);
    if (result) void Promise.resolve(result).catch(() => {});
  } catch {
    // Analytics is optional and must never interrupt a customer interaction.
  }
}
